import { InfoDialogTranslation } from '@/assets/locales/components/infoDialog/infoDialog.translation.en.ts';

export const infoDialogTranslation: InfoDialogTranslation = {
  buttons: {
    close: 'Zamknij',
    ok: 'Ok',
  },
  title: 'Informacja',
};
